function enhanceSccAboutPage() {
  const root = document.querySelector('#MainContent[data-scc-page-handle="about"]');
  const formatter = root?.querySelector('.page-content rte-formatter');

  if (!formatter || formatter.dataset.sccAboutEnhanced === 'true') return;

  const nodes = Array.from(formatter.children);
  const intro = nodes[0]?.matches('p') ? nodes.shift() : null;
  const stories = document.createElement('div');
  let activeBody = null;
  let storyIndex = 0;

  formatter.dataset.sccAboutEnhanced = 'true';
  stories.className = 'scc-about-stories';

  if (intro) {
    intro.classList.add('scc-about-intro');
    intro.after(stories);
  } else {
    formatter.prepend(stories);
  }

  nodes.forEach((node) => {
    if (node.matches('h2')) {
      storyIndex += 1;

      const story = document.createElement('section');
      const body = document.createElement('div');
      const headingId = node.id || `scc-about-story-${storyIndex}`;

      node.id = headingId;
      story.className = 'scc-about-story';
      story.setAttribute('aria-labelledby', headingId);
      body.className = 'scc-about-story__body';
      story.append(node, body);
      stories.append(story);
      activeBody = body;
      return;
    }

    activeBody?.append(node);
  });

  stories.querySelectorAll('.scc-about-story').forEach((story) => {
    const body = story.querySelector('.scc-about-story__body');

    if (body?.querySelector('ul')) {
      story.classList.add('scc-about-story--shop');
    }

    if (!body?.querySelector('h3')) return;

    story.classList.add('scc-about-story--questions');

    const questionNodes = Array.from(body.children);
    const questionGrid = document.createDocumentFragment();
    let activeQuestion = null;

    questionNodes.forEach((node, index) => {
      if (node.matches('h3')) {
        activeQuestion = document.createElement('article');
        activeQuestion.className = 'scc-about-question';
        node.id ||= `scc-about-question-${index + 1}`;
        activeQuestion.setAttribute('aria-labelledby', node.id);
        activeQuestion.append(node);
        questionGrid.append(activeQuestion);
        return;
      }

      activeQuestion?.append(node);
    });

    body.append(questionGrid);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceSccAboutPage, { once: true });
} else {
  enhanceSccAboutPage();
}

document.addEventListener('shopify:section:load', enhanceSccAboutPage);
